import React from "react";
import HttpRequest from "~/common/utils/fetch";

const collectData = (data) => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV !== "production") {
      resolve("Data collected");
      return;
    }
    fetch(process.env.NEXT_PUBLIC_SS_METRICS_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (r) => {
        if (!r.ok) {
          reject("Error collecting data");
        }
        resolve("Data collected");
      })
      .catch((e) => {
        reject("Error collecting data");
      });
  });
};

export default function useCollectMetrics({ entity }) {
  const collectCarPageView = React.useCallback(
    (carId) => {
      const payload = {
        view_name: "car",
        view_value: carId,
      };
      try{
        collectData({
          type: "view",
          payload,
          entity,
        });
      } catch(e) {
        console.log(e)
      }
    },
    [entity]
  );

  const collectCarView = React.useCallback(
    (carId) => {
      const payload = JSON.stringify({
        carId,
      })
      HttpRequest({
        endpoint: "/api/metrics/car_view",
        method: "PUT",
        data: payload
      })
    }, [entity]
  )

  const collectInventaryPageView = React.useCallback(
    (businessId) => {
      const payload = {
        view_name: "inventary",
        view_value: businessId,
      };
      collectData({
        type: "view",
        payload,
        entity,
      });
    },
    [entity]
  );

  const collectWhatsappButtonClickAction = React.useCallback(
    (carId) => {
      const payload = {
        action_name: "whatsapp_button_click",
        action_value: carId,
      };
      collectData({
        type: "action",
        payload,
        entity,
      });
    },
    [entity]
  );

  const collectCallButtonClickAction = React.useCallback(
    (carId) => {
      const payload = {
        action_name: "call_button_click",
        action_value: carId,
      };
      collectData({
        type: "action",
        payload,
        entity,
      });
    },
    [entity]
  );

  return {
    collectCarView,
    collectCarPageView,
    collectInventaryPageView,
    collectCallButtonClickAction,
    collectWhatsappButtonClickAction,
  };
}
